import React, { createContext, useContext, useState, useMemo, useCallback } from "react";
import { translations } from "@/i18n";

const LangContext = createContext(null);

export const LangProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    const stored = typeof window !== "undefined" ? localStorage.getItem("cammino-lang") : null;
    return stored === "en" ? "en" : "it";
  });

  const toggle = useCallback(() => {
    setLang((prev) => {
      const next = prev === "it" ? "en" : "it";
      localStorage.setItem("cammino-lang", next);
      return next;
    });
  }, []);

  const setLangSafe = useCallback((v) => {
    const next = v === "en" ? "en" : "it";
    localStorage.setItem("cammino-lang", next);
    setLang(next);
  }, []);

  const t = useCallback((key) => translations[lang][key] ?? key, [lang]);

  const value = useMemo(() => ({ lang, setLang: setLangSafe, toggle, t }), [lang, setLangSafe, toggle, t]);
  return <LangContext.Provider value={value}>{children}</LangContext.Provider>;
};

export const useLang = () => {
  const ctx = useContext(LangContext);
  if (!ctx) throw new Error("useLang must be used within LangProvider");
  return ctx;
};
